module.exports = __webpack_public_path__ + "static/img/pandian.86342c3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/20250724/ruanjian/pandian.png
// module id = MEjo
// module chunks = 39